import styled, { keyframes } from 'styled-components';
import { Spinner2 } from 'styled-icons/evil';
import { darken } from 'polished';

import { Button } from '~/components';

export const Container = styled.div`
  height: 192px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const Label = styled.p`
  position: absolute;
  margin-top: 25px;
  margin-left: 15px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  color: rgba(0, 0, 0, 0.3);
`;

export const Title = styled.p`
  background-color: #f3f3f4;
  position: absolute;
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  margin-top: 40px;
  margin-left: 10px;
  color: ${({ theme }) => theme.dark};
  padding: 5px;
`;

export const DownloadButtonContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

export const DownloadButton = styled(Button)`
  height: 60px;
  width: 60px;
  border: none;
  background-color: ${({ theme }) => theme.coral};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -10px;
  margin-bottom: -10px;
  transition: background-color ease-in-out 0.1s;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.coral)};
  }
`;

export const Preview = styled.img`
  height: 100%;
  max-width: 230px;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(Spinner2)`
  color: ${({ theme }) => theme.whiteWithOpacity};
  animation: ${rotate} 0.8s linear infinite;
`;
